import { messages as spanishMessages } from "./es";

const messages = { ...spanishMessages };

export { messages };
